// @flow
import React from 'react'
import urlparameters from '../lib/urlparameters'

const LinkHP = (props) => {
  if (typeof window !== `undefined`) {
    if (
      props?.to?.indexOf('/contact/') !== -1 &&
      document?.URL?.indexOf('/contact/') === -1
    ) {
      sessionStorage.setItem('sourcePage', document.URL)
    }
  }
  
  const to = urlparameters(props.to, ['jumpid', 'bmtid'])
  
  return (
    <a {...props} href={to || props.href} data-chee onPointerDown={(event) => {
      console.log("stopping propagation")
      event.preventDefault()
      event.stopPropagation()
    }}>
      {props.children}
    </a>
  )
}

export default LinkHP
